import React from 'react';

interface Props {
  size?: number;
}

const SignalIcon: React.FC<Props> = ({ size = 20 }) => (
  <img
    src="https://lumahealth-assets.s3-us-west-2.amazonaws.com/OnlineSignal.gif"
    alt="Signal gif"
    height={size}
    width={size}
  />
);

export default SignalIcon;
